/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types'
import { Auth, Hub } from 'aws-amplify';
import { getStoreAuth } from '../services/authService';
import Loading from '../components/Loading';

const Login = ({history, isLoggedIn}) => {
  const [ isLoading, setIsLoading ] = useState(false)

  useEffect( () => {
    if (isLoggedIn){
      history.push('./home')
    }
  },[])

  const login = async () => {
    try {
      setIsLoading(true);
      const instoreAuthUsed = !!process.env.REACT_APP_BASE_INSTORE_API_URI;
      let storeAuth;
      if (instoreAuthUsed){
        storeAuth = await getStoreAuth();
      }
      if(!storeAuth || storeAuth === "not in store"){
        console.log(storeAuth, 'switching to Okta');
        Auth.federatedSignIn();
      } else {
        Hub.dispatch('storeAuth', {event: 'signIn', data: storeAuth} )
      } 
    } catch(error){
      console.log(error)
      setIsLoading(false)
    }
  }

  return (
    <div className="login-container">
      {isLoading?
        (
          <Loading isLoading={isLoading} />
        ):(
        <button type="button" className="login-button" onClick={login}>
          Login
        </button>
        )

      }
    </div>
  )
}

Login.propTypes = {
  history: ReactRouterPropTypes.history,
  isLoggedIn: PropTypes.bool.isRequired,
}

export default withRouter(Login)

